export default function (Component) {
Component.options.__docs = "<p>You can use <code>striped</code> on <code>FdTable</code> in order enable alternating colored rows.</p>\n"
}